import $ from "cash-dom";
//b/c (for some strange reason) browsers doesn't display elements with fill=url(...) after page loaded - we need to update them
$(function () {
    $('svg').each((svgIndex, svgEl) => {
        let elementsWithUrl = $(svgEl).find("[fill^='url']");

        if (elementsWithUrl && elementsWithUrl.length) {
            elementsWithUrl.each((elementWithUrlIndex, elementWithUrl) => {
                let fillIdMatch = $(elementWithUrl).attr('fill').match(/url\(#([0-9A-Za-z\-_]+)\)/);

                if (fillIdMatch && fillIdMatch[1]) {
                    let elementWithId = $(svgEl).find("#" + fillIdMatch[1]);

                    if (elementWithId && elementWithId.length) {
                        let newId = fillIdMatch[1] + '_' + svgIndex + '_' + elementWithUrlIndex;

                        $(elementWithId).attr('id', newId);
                        $(elementWithUrl).attr('fill', 'url(#' + newId + ')')
                    }
                }
            });
        }
    });
});